module.exports = {
  name: 'date', base: 'datemonth', prototype: {
    element_selector: 'input.date, .date input',

    _month_name: 'name_genitive',

    _spliters: ['-', '-', '']
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/date.js
 ** module id = 12
 ** module chunks = 0
 **/